import {MultiRunWorkspaceQueryData} from '../../state/graphql/multiRunWorkspaceQuery';
import {RunsQueryContext} from '../../state/runs/context';
import {ProjectPageViewSpec} from '../../state/views/projectPage/types';
import {
  GenericWorkspacePageData,
  MultiRunWorkspacePageData,
} from '../../state/workspaces/selectors';
import * as FilterTypes from '../../util/filterTypes';
import {Grouping} from '../../util/queryTypes';
import * as RunTypes from '../../util/runTypes';
import {RecommendGrouping, ViewType} from '../Workspace/multiRunWorkspaceHooks';
import {SemanticLegendSettingsWithCategoricalConfig} from '../WorkspaceDrawer/Settings/types';

export type MultiRunWorkspaceWorkspaceProps = MultiRunWorkspaceProps &
  MultiRunWorkspaceReadyProps;

export interface MultiRunWorkspaceProps {
  children?: React.ReactNode;
  defaultSpecPostFn?: (spec: ProjectPageViewSpec) => ProjectPageViewSpec;
  entityName: string;
  isSingleMode?: boolean;
  isTableExpanded: boolean;
  mergeFilters?: FilterTypes.Filter<RunTypes.Key>;
  onSelectRunName?: (runId: string) => void;
  onSetTableExpanded?: (isTableExpanded: boolean) => void;
  projectName: string;
  recommendGrouping: RecommendGrouping;
  runSetName?: string;
  runsQueryContextValue?: Partial<RunsQueryContext>;
  selectedRunName?: string;
  semanticLegendSettings?: SemanticLegendSettingsWithCategoricalConfig;
  showArtifactCounts?: boolean;
  showLogCounts?: boolean;
  title: string | React.ReactElement;
  viewType: ViewType;
  workspaceObjectID?: string;
}

export interface MultiRunWorkspaceReadyProps {
  project: MultiRunWorkspaceQueryData['project'];
  defaultSpec: ProjectPageViewSpec;
  recommendedGrouping: Grouping;
}

export type MultiRunWorkspaceAllProps = MultiRunWorkspaceWorkspaceProps &
  MultiRunWorkspacePageData &
  GenericWorkspacePageData & {
    workspaceID: string;
  };
